import type { FC } from "react";

import { HostResponseCodeSearchForm } from "src/app/features/HostResponseCode/components/forms/HostResponseCodeSearchForm";
import { HostResponseCodesTable } from "src/app/features/HostResponseCode/components/tables/HostResponseCodesTable";
import type { HostResponseCodeEntity } from "src/app/features/HostResponseCode/types/HostResponseCodeEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const HostResponseCodesPage: FC<NoneOwnProps> = () => {
    const table = <HostResponseCodesTable />;
    const searchForm = <HostResponseCodeSearchForm />;
    const hasAccess = canAccess(ResourceName.HOST_RESPONSE_CODE, "canRead");

    return (
        <PageLayout name="hostResponseCodes_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.hostResponseCodes" />
                    <ResourceManager<HostResponseCodeEntity>
                        useDataGroup
                        dataMapperKey="hostResponseCodeTableData"
                        resource={ResourceName.HOST_RESPONSE_CODE}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
